<template>
<kt-panel v-if="status === 'success'">
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse"
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row v-if="$can('read', 'ticket')">
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="id">
                                            {{ $t('label.ticket_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="id"
                                                dir="ltr"
                                                name="id"
                                                id="id"
                                                v-model="query.id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                    <kt-form-group>
                                        <kt-form-label for="category">
                                            {{ $t('label.category') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="category" class="form-control" name="category" v-model="query.category">
                                            <option :value="null"></option>
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(category, index) in categories"
                                                    v-bind:value="category.id"
                                                    :selected="query.category === category.id"
                                            >
                                                {{ category.label }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                  <kt-form-group ref="stamanagetusSelectGroup">
                                    <kt-form-label for="status">
                                      {{ $t('label.status') }}
                                    </kt-form-label>
                                    <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                      <option
                                          v-bind:key="index"
                                          v-for="(status, index) in statuses"
                                          v-bind:value="status.value"
                                          :selected="query.status === status.value"
                                      >
                                        {{ status.name }}
                                      </option>
                                    </kt-form-select>
                                  </kt-form-group>

                                  <!--                                    <kt-form-group>-->
<!--                                        <kt-form-label for="subject">-->
<!--                                            {{ $t('label.subject') }}-->
<!--                                        </kt-form-label>-->
<!--                                        <kt-form-control-->
<!--                                                ref="subject"-->
<!--                                                name="subject"-->
<!--                                                id="subject"-->
<!--                                                v-model="query.subject"-->
<!--                                        />-->
<!--                                    </kt-form-group>-->
                                </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                <kt-form-group>
                                  <kt-form-label for="full_name">
                                    {{ $t('label.ticket_full_name') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      ref="full_name"
                                      dir="ltr"
                                      name="full_name"
                                      id="full_name"
                                      v-model="query.full_name"
                                  />
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                <kt-form-group>
                                  <kt-form-label for="email">
                                    {{ $t('label.ticket_email') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      ref="email"
                                      dir="ltr"
                                      name="email"
                                      id="email"
                                      v-model="query.email"
                                  />
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                <kt-form-group>
                                  <kt-form-label for="subject">
                                    {{ $t('label.subject') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      ref="subject"
                                      name="subject"
                                      id="subject"
                                      v-model="query.subject"
                                  />
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                <kt-form-group>
                                  <kt-form-label for="from_date">
                                    {{ $t('label.from_date') }}
                                  </kt-form-label>
                                  <button id="from_date"
                                          @click="clearFromDate"
                                          class=" btn btn-label-danger trash-btn"
                                          type="button"
                                  >
                                    <i class="la la-trash-o"></i>
                                  </button>
                                  <datePicker
                                      format="YYYY-MM-DD HH:mm:ss"
                                      display-format="dddd jDD jMMMM jYYYY"
                                      input-class="form-control"
                                      v-model="query.from_date" type="date" />
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="3">
                                <kt-form-group>
                                  <kt-form-label for="to_date">
                                    {{ $t('label.to_date') }}
                                  </kt-form-label>
                                  <button id="to_date"
                                          @click="clearToDate"
                                          class=" btn btn-label-danger trash-btn"
                                          type="button"
                                  >
                                    <i class="la la-trash-o"></i>
                                  </button>
                                  <datePicker
                                      format="YYYY-MM-DD HH:mm:ss"
                                      display-format="dddd jDD jMMMM jYYYY"
                                      input-class="form-control"
                                      v-model="query.to_date" type="date" />
                                </kt-form-group>
                              </kt-col>
                              <kt-col xs="12" sm="6" md="3">
                                <kt-form-group ref="statusSelectGroup">
                                  <kt-form-label for="point">
                                    {{ $t('label.point') }}
                                  </kt-form-label>
                                  <select size="3" multiple id="point" name="point" v-model="query.point" class="form-control kt-selectpicker">
                                    <option
                                        v-for="score in scores" :value="score.value">
                                      {{ score.name }}
                                    </option>
                                  </select>
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                <kt-form-group>
                                  <kt-form-label for="responsible_name">
                                    {{ $t('label.responsible_name') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      ref="responsible_name"
                                      dir="rtl"
                                      name="responsible_name"
                                      id="responsible_name"
                                      v-model="query.responsible_name"
                                  />
                                </kt-form-group>
                              </kt-col>
                            </kt-form-row>
                            <kt-form-row v-else>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="id">
                                            {{ $t('label.id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="id"
                                                dir="ltr"
                                                name="id"
                                                id="id"
                                                v-model="query.id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="created_at">
                                            {{ $t('label.created_at') }}
                                        </kt-form-label>
                                        <button @click="clearCreatedAt"
                                                class=" btn btn-label-danger trash-btn"
                                                type="button"
                                        >
                                            <i class="la la-trash-o"></i>
                                        </button>
                                        <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                v-model="query.created_at" type="date" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="category">
                                            {{ $t('label.category') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="category" class="form-control" name="category" v-model="query.category">
                                            <option :value="null"></option>
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(category, index) in categories"
                                                    v-bind:value="category.id"
                                                    :selected="query.category === category.id"
                                            >
                                                {{ category.label }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                <kt-form-group>
                                  <kt-form-label for="subject">
                                    {{ $t('label.subject') }}
                                  </kt-form-label>
                                  <kt-form-control
                                      ref="subject"
                                      name="subject"
                                      id="subject"
                                      v-model="query.subject"
                                  />
                                </kt-form-group>
                              </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                <kt-form-group>
                                  <kt-form-label for="status">
                                    {{ $t('label.status') }}
                                  </kt-form-label>
                                  <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                    <option
                                        v-bind:key="index"
                                        v-for="(status, index) in statuses"
                                        v-bind:value="status.value"
                                        :selected="query.status === status.value"
                                    >
                                      {{ status.name }}
                                    </option>
                                  </kt-form-select>
                                </kt-form-group>
                              </kt-col>
                            </kt-form-row>
                            <kt-form-row>
                            </kt-form-row>
                        </kt-form-section>

                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { ticketStatus, statusStr } from '@/constants/ticketStatus'
import { mapGetters } from 'vuex';
import $ from 'jquery'
import {i18n} from "@/plugins/i18n";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data: function() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name:   statusStr.CREATED_BY_ADMIN,
                    value:  ticketStatus.CREATED_BY_ADMIN
                },
                {
                    name:   statusStr.SEEN_BY_ADMIN,
                    value:  ticketStatus.SEEN_BY_ADMIN
                },
                {
                    name:   statusStr.REPLIED_BY_ADMIN,
                    value:  ticketStatus.REPLIED_BY_ADMIN
                },
                {
                    name:   statusStr.SEEN_BY_USER,
                    value:  ticketStatus.SEEN_BY_USER
                },
                {
                    name:   statusStr.REPLIED_BY_USER,
                    value:  ticketStatus.REPLIED_BY_USER
                },
                {
                    name:   statusStr.CLOSED,
                    value:  ticketStatus.CLOSED
                },
            ],
            scores: [
              {
                name: 1,
                value: 1
              },
              {
                name: 2,
                value: 2
              },
              {
                name: 3,
                value: 3
              },
              {
                name: 4,
                value: 4
              },
              {
                name: 5,
                value: 5
              },
            ],
            query: {
                point: [],
            },
        }
    },
    computed: {
        ...mapGetters('ticket', [
            'status',
            'categories'
        ])
    },
    mounted() {
          setInterval( () => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        })
    },
    methods: {
        clearCreatedAt() {
            if(this.query.created_at) {
                this.query.created_at = null
            }
        },
        clearFromDate() {
              if(this.query.from_date) {
                  this.query.from_date = null
              }
        },
        clearToDate() {
              if(this.query.to_date) {
                  this.query.to_date = null
              }
        },
    }
}
</script>

<style>

</style>